<template>
  <div>
    <div class="title">如何订购商品？</div>
    <div class="content-info">
      <ul>
        <li>
          <img
            src="https://img-oss.yunshanmeicai.com/cfile/b999798e8a4e84a7d89eb119720bc470.png"
            width="517"
          />
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: "register",
  data() {
    return {};
  }
};
</script>

<style lang="scss" scoped>
</style>
